/**
 * Модуль для работы с блоком 'Перейти к разделу'
 *
 */

( function () {
    'use strict';

    let selectorContainer = '.go-to-section';
    let container = document.querySelector(selectorContainer);
    if (!container) {
        return;
    }

    let sectionsList = container.querySelector('.js-sections-list');
    let btnGoToSection = container.querySelector('.js-btn-go-to-section');
    let inputCheckbox = container.querySelector('input[type="checkbox"]');

    init();

    /**
     * Инициализация
     *
     */
    function init() {
        onHashChanged();
        onSectionClick();
        onBtnGoToSectionClick();
        onInputCheckboxChange();
        onKeyDown();

        if (!isSupportVh()) {
            setMaxHeight();
        }

    }

    /**
     * Определяет равен ли хэш #sections-list
     *
     * @returns {Boolean}
     */
    function hashIsEqualSectionsList() {
        return (window.location.hash === '#sections-list');
    }

    /**
     * Открывает список разделов
     *
     */
    function open() {
        inputCheckbox.checked = true;
        // inputCheckbox.classList.add('go-to-section__checkbox--checked');
        sectionsList.classList.add('go-to-section__sections-list--show');

        showButtons(false);
    }

    /**
     * Производит закрытие списка разделов
     *
     */
    function close() {
        inputCheckbox.checked = false;
        // inputCheckbox.classList.remove('go-to-section__checkbox--checked');
        sectionsList.classList.remove('go-to-section__sections-list--show');

        showButtons(true);
    }

    function showButtons(show) {
        let buttons = container.querySelectorAll('.fixed-buttons__btn:not(.go-to-section__btn)');
        if (!buttons) {
            return;
        }

        [].forEach.call(buttons, (button) => {
            if (show) {
                button.classList.remove('fixed-buttons__btn--hide');
            } else {
                button.classList.add('fixed-buttons__btn--hide');
            }

        });
    }

    function pubEvent(eventName, data) {
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(eventName, true, true, data);
        document.dispatchEvent(evt);
    }

    function setMaxHeight() {
        let heightWindow = parseInt(window.innerHeight, 10);

        sectionsList.style.maxHeight =
            (heightWindow
                - container.getBoundingClientRect().height
                - parseInt(getComputedStyle(sectionsList).marginBottom, 10)
            ) + 'px';
    }

    function isSupportVh() {
        let element = document.querySelector('.js-support');
        if (!element) {
            return true;
        }

        element.style.height = '50vh';

        let halfHeight = parseInt(window.innerHeight / 2, 10);
        let elementHeight = parseInt(getComputedStyle(element).height, 10);
        let isSupport = (halfHeight === elementHeight);

        element.style.height = '';

        return isSupport;
    }

    /**
     * Обработка клика по разделу
     *
     */
    function onSectionClick() {
        sectionsList.addEventListener('click', function (e) {
            if (e.target.classList.contains('js-section-link')) {
                close();
            }

            if (e.target.tagName.toLowerCase() === 'a') {
                e.preventDefault();
                window.scrollToElement(document.querySelector(e.target.hash));
            }

        });
    }

    /**
     * Обработка клика по кнопке Разделы
     *
     */
    function onBtnGoToSectionClick() {
        btnGoToSection.addEventListener('click', function () {
            pubEvent('close-menu', {});
        });
    }

    /**
     * Обработка события:
     *
     */
    function onInputCheckboxChange() {
        inputCheckbox.addEventListener('change', (evt) => {
            if (evt.target.checked) {
                open();
            } else {
                close();
            }
        });
    }

    /**
     * Обработчик изменения хэша адресной строки
     *
     */
    function onHashChanged() {
        window.addEventListener('hashchange', function () {
            if (hashIsEqualSectionsList()) {
                if (!inputCheckbox.checked && document.referrer) {
                    window.location.assign(document.referrer)
                }
            } else {
                close();
            }
        });
    }

    /**
     * Обработчик события: нажатие клавиши
     *
     */
    function onKeyDown() {
        window.addEventListener('keydown', function (e) {
            if (e.keyCode === 27) {
                close();
            }
        });
    }

}());

